export default __webpack_public_path__ + "static/media/s8.1b41a2d9.jpg";